import { render, staticRenderFns } from "./VerifyPoints.vue?vue&type=template&id=7531a50f&"
import script from "./VerifyPoints.vue?vue&type=script&lang=js&"
export * from "./VerifyPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7531a50f', component.options)
    } else {
      api.reload('7531a50f', component.options)
    }
    module.hot.accept("./VerifyPoints.vue?vue&type=template&id=7531a50f&", function () {
      api.rerender('7531a50f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/verify/components/Verify/VerifyPoints.vue"
export default component.exports